var ImovelConcedido = /** @class */ (function () {
    function ImovelConcedido() {
    }
    return ImovelConcedido;
}());
export { ImovelConcedido };
